module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<div class=\"app\" [ngClass]=\"{'light': currentBookingOptions.theme === 'Light', 'dark': currentBookingOptions.theme === 'Dark'}\">\n  <consentz-header-component *ngIf=\"(permission$ | async).permissionHeader\"></consentz-header-component>\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main